import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppIaRWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import { initialize } from '../state/appSlice';
import Main from './Main';
import { persistor, RootState, AppDispatch } from './store';

const useInitialize = (dispatch: AppDispatch) => {
  useEffect(() => {
    (async () => {
      const action: any = await dispatch(initialize());
      if (action && (action as any).error) {
        throw new Error((action as any).error as string);
      }
    })();
  }, [dispatch]);
};

const App: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialized, initializing, initError } = useSelector(
    (state: RootState) => state.landingZones,
  );
  useInitialize(dispatch);

  return useMemo(() => {
    if (initError) {
      return <ErrorPage persistor={persistor} />;
    }

    if (initializing) {
      return <AppLoading />;
    }

    if (initialized) {
      return (
        <AppIaRWrapper>
          <Main />
        </AppIaRWrapper>
      );
    }

    return <ErrorPage persistor={persistor} />;
  }, [initialized, initializing, initError]);
};

export default App;
